/**
 * Test IDs for QA automation.
 */
export const testIds = {
  weeklyForecastModelSlotFormSalesAmount: "weekly-forecast-model-slot-form-sales-amount",
} as const;
